<template>
    <hts-drawer
        v-model="visible"
        :title="$t('Tạo kết nối')"
        :rules="rulesForm"
        :submit="submit">
        <div class="p-4">
            <hts-form-input
                v-model="formData.workspaceId"
                :label="$t('labels.workspaceId')"
                prop="workspaceId"
                name="workspaceId"
                placeholder="Workspace id xuất khẩu và nhập khẩu"
                required />

            <h3 class="mt-6 text-xl font-semibold">
                Sau khi workspace xuất nhập khẩu xác nhận lời mời:
            </h3>
            <ul class="list-disc pl-5 mt-2 text-gray-700">
                <li class="mb-2">
                    Hệ thống sẽ tự động tạo một khách hàng mới trong phần <strong>
                        Quản lý công ty
                    </strong>.
                </li>
                <li>
                    Workspace được kết nối sẽ được cấp quyền truy cập để xem thông tin đơn hàng và chuyến hàng của khách hàng mới này.
                </li>
            </ul>
        </div>
    </hts-drawer>
</template>

<script setup lang="ts">
const emits = defineEmits(['refreshTables'])
const visible = ref(false)

const formData = ref({
  workspaceId: ''
})

const open = () => {
  visible.value = true
}

const submit = () => {
  const api = $url.company.integration.internal.create

  $api(api, { body: formData.value }).then((data) => {
    const resData: any = data?.data?.value

    if (resData?.success) {
      process.client && $toast().success('Yêu cầu kết nối thành công')
      reset()
      close()
      emits('refreshTables')
    }
  })
}

const reset = () => {
  formData.value.workspaceId = ''
}

const close = () => {
  visible.value = false
}

const rulesForm = {
  workspaceId: 'required'
}

defineExpose({
  open
})
</script>
